/**
 * @fileoverview gRPC-Web generated client stub for activity
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: activity/activity.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.activity = require('./activity_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ActivityLogClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ActivityLogPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityLogRequest,
 *   !proto.activity.ActivityLogEntries>}
 */
const methodDescriptor_ActivityLog_GetActivityLogs = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityLogs',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityLogRequest,
  proto.activity.ActivityLogEntries,
  /**
   * @param {!proto.activity.GetActivityLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityLogEntries.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityLogEntries)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityLogEntries>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityLogs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogs',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogs,
      callback);
};


/**
 * @param {!proto.activity.GetActivityLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityLogEntries>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityLogs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogs',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityLogCitationRequest,
 *   !proto.activity.ActivityLogEntries>}
 */
const methodDescriptor_ActivityLog_GetActivityLogsCitation = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityLogsCitation',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityLogCitationRequest,
  proto.activity.ActivityLogEntries,
  /**
   * @param {!proto.activity.GetActivityLogCitationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityLogEntries.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityLogCitationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityLogEntries)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityLogEntries>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityLogsCitation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogsCitation',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogsCitation,
      callback);
};


/**
 * @param {!proto.activity.GetActivityLogCitationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityLogEntries>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityLogsCitation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogsCitation',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogsCitation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityCountRequest,
 *   !proto.activity.ActivityEntryCount>}
 */
const methodDescriptor_ActivityLog_GetActivityCount = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityCount',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityCountRequest,
  proto.activity.ActivityEntryCount,
  /**
   * @param {!proto.activity.GetActivityCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityEntryCount.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityEntryCount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityEntryCount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityCount',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityCount,
      callback);
};


/**
 * @param {!proto.activity.GetActivityCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityEntryCount>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityCount',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityCountCitiationRequest,
 *   !proto.activity.ActivityEntryCount>}
 */
const methodDescriptor_ActivityLog_GetActivityCountCitation = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityCountCitation',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityCountCitiationRequest,
  proto.activity.ActivityEntryCount,
  /**
   * @param {!proto.activity.GetActivityCountCitiationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityEntryCount.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityCountCitiationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityEntryCount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityEntryCount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityCountCitation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityCountCitation',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityCountCitation,
      callback);
};


/**
 * @param {!proto.activity.GetActivityCountCitiationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityEntryCount>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityCountCitation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityCountCitation',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityCountCitation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityLogInfosRequest,
 *   !proto.activity.ActivityLogInfosResponse>}
 */
const methodDescriptor_ActivityLog_GetActivityLogInfos = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityLogInfos',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityLogInfosRequest,
  proto.activity.ActivityLogInfosResponse,
  /**
   * @param {!proto.activity.GetActivityLogInfosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityLogInfosResponse.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityLogInfosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityLogInfosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityLogInfosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityLogInfos =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogInfos',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogInfos,
      callback);
};


/**
 * @param {!proto.activity.GetActivityLogInfosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityLogInfosResponse>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityLogInfos =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogInfos',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogInfos);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.GetActivityLogErrorsRequest,
 *   !proto.activity.ActivityLogErrorsResponse>}
 */
const methodDescriptor_ActivityLog_GetActivityLogErrors = new grpc.web.MethodDescriptor(
  '/activity.ActivityLog/GetActivityLogErrors',
  grpc.web.MethodType.UNARY,
  proto.activity.GetActivityLogErrorsRequest,
  proto.activity.ActivityLogErrorsResponse,
  /**
   * @param {!proto.activity.GetActivityLogErrorsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.ActivityLogErrorsResponse.deserializeBinary
);


/**
 * @param {!proto.activity.GetActivityLogErrorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.ActivityLogErrorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.ActivityLogErrorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ActivityLogClient.prototype.getActivityLogErrors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogErrors',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogErrors,
      callback);
};


/**
 * @param {!proto.activity.GetActivityLogErrorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.ActivityLogErrorsResponse>}
 *     Promise that resolves to the response
 */
proto.activity.ActivityLogPromiseClient.prototype.getActivityLogErrors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.ActivityLog/GetActivityLogErrors',
      request,
      metadata || {},
      methodDescriptor_ActivityLog_GetActivityLogErrors);
};


module.exports = proto.activity;

